import { FC } from 'react'
import styles from './index.module.scss'
import { ILocationBase } from '../../../types'
import { SelectedTag } from '../SelectedTag'
import { LocationSearchField } from '../../molecules/LocationSearchField'

type Props = {
  selectedLocations: ILocationBase[]
  setFieldValue: (locations: ILocationBase[]) => void
}

export const LocationField: FC<Props> = ({ selectedLocations, setFieldValue }) => {
  return (
    <>
      <div className={styles.tags}>
        {selectedLocations?.map((location) => {
          return (
            <div key={location?.id} className={styles.item}>
              <SelectedTag
                name={location?.name}
                nameTestid={`locationName${location.id}`}
                buttonTestid={`locationDeleteButton${location.id}`}
                onDeleteClick={() =>
                  setFieldValue(
                    selectedLocations?.filter((l) => l?.slug !== location?.slug) // 削除する location 以外の配列を値にセットする
                  )
                }
              />
            </div>
          )
        })}
      </div>
      <LocationSearchField
        selectedLocations={selectedLocations}
        setFieldValue={(locations) => setFieldValue(locations)}
      />
    </>
  )
}
